import React, { useState } from "react";
import axios from "axios";
import {
  IconButton, TextField
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import DefaultButton from "../../../styles/materialButtonStyle";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import MaterialDialog from "../../../styles/materialDialog";
import {
  StyledDialogAction,
  StyledDialogContent,
  StyledDialogHead,
  StyledDialogWrapper
} from "../../../styles/styledDialog";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";

const EMPTY_FORM = { projectId: "", token: "" };

const TelegramCreateBotDialog = ({ setNotification, onCreated, t }) => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(EMPTY_FORM);
  const [showToken, setShowToken] = useState(false);
  const [saving, setSaving] = useState(false);
  const [projects, setProjects] = useState([]);

  const handleOpen = () => {
    setForm(EMPTY_FORM);
    setShowToken(false);
    setOpen(true);
    axios.get("/api/projects?itemsPerPage=200", userAuthenticationConfig()).then(response => setProjects(response.data["hydra:member"] || [])).catch(() => {});
  };

  const handleSave = () => {
    if (!form.projectId || !form.token.trim()) {
      setNotification({ visible: true, type: "error", message: t("bots.errors.fieldsRequired") });
      return;
    }
    setSaving(true);
    axios.post("/api/telegram/bots", {
      projectId: form.projectId,
      token: form.token.trim()
    }, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setOpen(false);
        onCreated();
        if (response.data.webhookOk) {
          setNotification({ visible: true, type: "success", message: t("bots.success.savedWithWebhook") });
        } else {
          const hint = response.data.webhookMessage || t("bots.errors.webhookFailed");
          setNotification({ visible: true, type: "warning", message: `${t("bots.success.savedNoWebhook")}: ${hint}` });
        }
      }
    }).catch(error => {
      const status = error?.response?.status;
      const msg = status === 409
        ? t("bots.errors.tokenConflict")
        : error?.response?.data?.message || t("bots.errors.save");
      setNotification({ visible: true, type: "error", message: msg });
    }).finally(() => setSaving(false));
  };

  return (
    <>
      <div className="content-head">
        <DefaultButton color="success" onClick={handleOpen}>
          {t("bots.createBot")}
        </DefaultButton>
      </div>

      <MaterialDialog open={open}>
        <StyledDialogWrapper>
          <StyledDialogHead>
            {t("bots.dialog.createTitle")}
          </StyledDialogHead>
          <StyledDialogContent>
            <FormControl>
              <Autocomplete
                options={projects}
                value={projects.find(p => String(p.id) === form.projectId) || null}
                onChange={(event, project) => setForm(f => ({ ...f, projectId: project ? String(project.id) : "" }))}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                  <TextField {...params} label={t("bots.dialog.project")} />
                )}
                blurOnSelect
                disableClearable
              />
            </FormControl>
            <FormControl>
              <InputLabel htmlFor="password">{t("bots.dialog.token")}</InputLabel>
              <Input
                type={showToken ? "text" : "password"}
                value={form.token}
                onChange={e => { const v = e.target.value; setForm(f => ({ ...f, token: v })); }}
                required
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      aria-label="toggle password visibility"
                      onClick={() => setShowToken(v => !v)}
                    >
                      <span className={showToken ? "icon-light-eye-slash" : "icon-light-eye"} />

                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          </StyledDialogContent>
          <StyledDialogAction col="2">
            <DefaultButton
              onClick={() => setOpen(false)}
              color="danger"
              disabled={saving}
            >
              {t("bots.dialog.cancel")}
            </DefaultButton>
            <DefaultButton
              color="success"
              onClick={handleSave}
              disabled={saving}
            >
              {t("bots.dialog.save")}
            </DefaultButton>
          </StyledDialogAction>
        </StyledDialogWrapper>
      </MaterialDialog>
    </>
  );
};

export default TelegramCreateBotDialog;
